var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.querySearchAsync,"placeholder":"隊編、姓名、電話","clearable":"","autocomplete":"off"},on:{"select":_vm.handleSelect,"clear":_vm.handleClear},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-775828da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element_ui/InputAutocomplete.vue
// module id = null
// module chunks = 